import Image from 'next/image';
export { List } from './List';
export { Div } from './Div';
export { Table } from './Table';
export { Image };
export { Img } from './Img';
export { Video } from './Video';
